var map = {
	"./icon.svg": 1607,
	"./tiny-pause-logo.svg": 6763
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(function(id) {
		return __webpack_require__.t(id, 1);
	});
}
function webpackAsyncContextResolve(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 4939;
module.exports = webpackAsyncContext;